<embed [src]="path() | safe" width="100%" height="100%" type="application/pdf" crossorigin />
